export const getCustomAlarmDefinitionsQuery = () => `
query getCustomAlarmDefinitions($type: DefinedFromDomainType!, $domainEntityId: UUID, $onlyActive: Boolean) {
    customAlarmDefinitions(type: $type, domainEntityId: $domainEntityId, onlyActive: $onlyActive) {
        id
        name
        eventsToTrack {
            id
            displayName
        }
        trackingTypeConfiguration {
            type
            windowDays
        }
        grayNotification {
            enabled
            numberOfEvents
        }
        yellowNotification {
            enabled
            numberOfEvents
        }
        redNotification {
            enabled
            numberOfEvents
        }
        isResettable
        requiresCommentOnReset
        active
    }
}
`;

export const deleteCustomAlarmDefinitionsMutation = () => `
    mutation deleteCustomAlarmDefinitions($ids: [UUID!]!) {
        deleteCustomAlarmDefinitions(ids: $ids) 
    }
`;

export const updateCustomAlarmsActiveStatusMutation = () => `
    mutation updateCustomAlarmDefinitionsActiveStatus($ids: [UUID!]!, $active: Boolean!) {
        updateCustomAlarmDefinitionsActiveStatus(ids: $ids, active: $active)
    }
`;
